import { render, staticRenderFns } from "./OpenDialogConfirmar.vue?vue&type=template&id=f31d5f08"
import script from "./OpenDialogConfirmar.vue?vue&type=script&lang=ts"
export * from "./OpenDialogConfirmar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports